import React from 'react';
import { Box, Typography } from '@mui/material';
import AboutSectionCarousel from '../components/Carousels/AboutSectionCarousel';


const AboutSection = () => {

  return (
    <Box>
      <Box sx={{ py: 5, mx: 5 }}>
        <Box>
          <Box sx={{ textAlign: 'center', my: 5 }}>
            <Typography variant="h2" component="h2" sx={{ color: 'darkOrange', fontWeight: 'bold', mb: 3 }}>
              Our VISION
            </Typography>
            <Typography sx={{ mb: 2 }}>
              To educate and empower marginalized girls from the Maasai community.
            </Typography>
            <Typography sx={{ mb: 3 }}>
              We have been sponsoring girls’ tuition for education since 1998.
            </Typography>
          </Box>

          <AboutSectionCarousel />

          <Box sx={{ textAlign: 'center', my: 5 }}>
            <Typography variant="h2" component="h2" sx={{ color: 'darkOrange', fontWeight: 'bold', mb: 3 }}>
              Our MISSION
            </Typography>
            <Typography variant='h6' sx={{ color: 'black', fontWeight: 'bold' }}>
              To empower girls from vulnerable Maasai communities
            </Typography>
            <Typography >
              through giving them access to quality education characterized by critical thinking and leadership skills which prepare them to become independent and successful women with dignified jobs, healthy families and of great impact in their communities.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutSection;
